import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxSpinnerModule } from "ngx-spinner";
import { ComponentsModule } from './components/components.module';
import { MasterRoutingModule } from './master-routing.module';
import { MasterComponent } from './master.component';


@NgModule({
  declarations: [
    MasterComponent,
  ],

  imports: [
    MasterRoutingModule,
    NgxSpinnerModule,
    ComponentsModule,
  ],
  exports: [
    CommonModule
  ],
  bootstrap: []
})
export class MasterModule { }
